import { useAuthStore } from '@shared/model'
import { useCustomerStore } from '@entities/customer'
import { useKidStore } from '@entities/customer'
import { useDisciplineStore } from '@entities/customer'
import { useSettingsStore } from '@shared/model'
import { useListsStore } from '@shared/model'
import { useBookingStore } from '@entities/booking'
import { usePadStore } from '@features/choose-plan'
import { useProgressReportStore } from '@entities/progress-report'
import { useScheduleStore } from '@entities/schedule'
import { useCheckoutStore } from '@entities/order'
import { useAiSummarizeStore } from '@entities/ai-summary'
import { useAssessmentResultStore } from '@entities/assessment'

interface LogOutOptions {
  navigate?: boolean
}

interface LogOutReturn {
  logout: (options?: LogOutOptions) => Promise<void>
}

export const useLogOut = (): LogOutReturn => {
  const authStore = useAuthStore()
  const customerStore = useCustomerStore()
  const kidStore = useKidStore()
  const disciplineStore = useDisciplineStore()
  const bookingStore = useBookingStore()
  const settingsStore = useSettingsStore()
  const listsStore = useListsStore()
  const padStore = usePadStore()
  const progressReportStore = useProgressReportStore()
  const scheduleStore = useScheduleStore()
  const checkoutStore = useCheckoutStore()
  const aiSummarizeStore = useAiSummarizeStore()
  const assessmentResultStore = useAssessmentResultStore()

  const resetKeyedStores = (): void => {
    disciplineStore.resetState()
    bookingStore.resetState()
    progressReportStore.resetState()
    scheduleStore.resetState()
    kidStore.resetState()
    checkoutStore.resetState()
    aiSummarizeStore.resetState()
    assessmentResultStore.resetState()
  }

  const logout = async (options?: LogOutOptions): Promise<void> => {
    const shouldNavigate = options?.navigate ?? true

    customerStore.clear()
    kidStore.clear()
    settingsStore.clear()
    listsStore.clear()
    padStore.clear()
    resetKeyedStores()

    if (!shouldNavigate) {
      authStore.reset()
      return
    }

    await authStore.logout()
  }

  return {
    logout,
  }
}
